// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2jXLX","content":"RecentSearches_content__27b-z"};